// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__fKKq9","link":"Navigation_link__WEg+Q","active":"Navigation_active__5HrdT"};